import { getSelectedFinanziamento } from './findomesticUtils'

export const validaCheckBoxes = (checkBoxes, checkBoxErrors, setState) => {
  const errors = Object.keys(checkBoxes)
    .map(name => {
      const checkbox = checkBoxes[name]
      let ret = false
      if (!checkbox.accepted && !checkbox.optional) {
        const _checkBoxErrors = checkBoxErrors
        _checkBoxErrors[name] = 'error'
        ret = true
        setState({ checkBoxErrors })
      }
      return ret
    })
    .filter(_ => _)

  return errors.length === 0
}

export const getFinanziamentoAssicurato = (
  findomestic,
  ordine,
  financements
) => {
  if (findomestic.finanziamentoAssicurato) {
    if (
      findomestic.finanziamentoAssicurato.id_finanziamento ===
      ordine.id_finanziamento
    ) {
      return findomestic.finanziamentoAssicurato
    }
  }

  // se l'id finanzimanento assicurato non e' quello
  // associato all'ordine
  // allora torniamo il finanziamento di classico
  return getSelectedFinanziamento(ordine, financements)
}

export const getFinanziamentoNonAssicurato = (
  findomestic,
  ordine,
  financements
) => {
  if (findomestic.finanziamentoAssicurato) {
    if (
      findomestic.finanziamentoAssicurato.id_finanziamento ===
      ordine.id_finanziamento
    ) {
      // il finanziamento non assicurato
      // e' quello classico se esiste un
      // finanziamento assicurato
      return getSelectedFinanziamento(
        { id_finanziamento: ordine.id_finanziamento_non_assicurato },
        financements
      )
    }
    if (
      findomestic.servizi_assicurativi &&
      findomestic.servizi_assicurativi.length
    ) {
      // oppure il classico se ci sono servizi assicurativi selezionati
      return getSelectedFinanziamento(
        { id_finanziamento: ordine.id_finanziamento },
        financements
      )
    }
  }

  // non ci sono servizi assicurativi selezionati
  // non ci sono finanziamenti assicurati

  return null
}
